import { render, staticRenderFns } from "./MoratoriaSojaPontos.vue?vue&type=template&id=2415cb12&lang=pug"
import script from "./MoratoriaSojaPontos.vue?vue&type=script&lang=js"
export * from "./MoratoriaSojaPontos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports